import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonWorkerOverview, CommonWorkerTopics } from "../../CommonComponents/CommonWorkerViews";

export const InfrastructureWorkerRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.workerMachine.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonWorkerOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonWorkerTopics />;
    },
};
